import { Component, OnInit, Input, SimpleChanges, EventEmitter, Output } from '@angular/core';
/*App imports*/
import { HelpersService } from '../../../../../services/tools/helpers.service';
import { VerdesService } from '../../../../../services/creditos/verdes.service';

@Component({
  selector: 'verde-capacidad-pago',
  templateUrl: './capacidad-pago.component.html'
})
export class VerdeCapacidadPagoComponent implements OnInit {

    @Input() public idCreditos: number = null;
    @Input() public isCompleted: boolean = false;
    @Input() public idTipos_Creditos: number = null;
    @Input() public isEditable: boolean = false;
    @Output() public onDataUpdated : EventEmitter<string> = new EventEmitter;
    //Cliente form
    public verde : any = {};
    public errors : any = {};
    private isInitialized : boolean = false;

    constructor(
      private helperService: HelpersService,
      private verdesService : VerdesService
    ){
    }

    ngOnInit() {
    }

    public loadComponent(){
      if(!this.isInitialized){
        this.getCredito(this.idCreditos);
        this.isInitialized = true;
      }
    }

    private getCredito(idCredito : number){
      
      //TODO: Manejar cuando el id no retorna un crédito valido
      this.verdesService.get(idCredito).subscribe(
        (response)=>
        {
          const result = response.json().content;
          this.verde = result.verde;
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
          
          if(error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
    }

    public save(){
      this.errors = {};

      const creditoVerde = this.verde;
      this.errors = this.verdesService.validateCapacidadPago(this.verde);

      if (Object.entries(this.errors).length > 0) {
        return false;
      }

      this.verdesService.updateCapacidadPago(creditoVerde).subscribe(
        (response)=>
        {
          this.helperService.notification('Avalúo actualizado', 'Se ha actualizado exitosamente la información del avalúo ', 'success');
          this.onDataUpdated.emit();
        }, error =>
        {
          // se resuelve error 403 y 500
          this.helperService.httpGlobalError(error);
  
          if(error.status == 400) { 
            this.setBackendErrors(error.json().content);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
  }

    /**
     * Helpers
     */
    private setBackendErrors(errors:any[]){
      let temp_errors = [];
      
      Object.keys(errors).forEach(function(key){
          temp_errors[key] = errors[key][0];
      });

      this.errors = temp_errors;
  }
}


// WEBPACK FOOTER //
// ./src/app/creditos/verde/detalles/components/capacidad-pago/capacidad-pago.component.ts